export enum ConfirmationActionModalBlock {
  Root = 'ConfirmationActionModal',
}
